import { render, staticRenderFns } from "./ListMyChannels.vue?vue&type=template&id=1f656079&scoped=true&"
import script from "./ListMyChannels.vue?vue&type=script&lang=js&"
export * from "./ListMyChannels.vue?vue&type=script&lang=js&"
import style0 from "./ListMyChannels.vue?vue&type=style&index=0&id=1f656079&prod&lang=sass&scoped=true&"
import style1 from "./ListMyChannels.vue?vue&type=style&index=1&id=1f656079&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f656079",
  null
  
)

export default component.exports